import ApplyJobsContainer from "../../../../Components/Miscellaneous/JobSearch/ApplyJobs/ApplyJobsContainer";

const JobApply = () => {
  return <ApplyJobsContainer />;
};

export default JobApply;
